<template>
  <div class="conteudoContainer">
    <div class="mapa">
      <div class="stepper" style="width: 30vw">
        <div v-if="simulacao != null">
          <div class="pl-4" style="display: flex; align-items: center">
            <div style="flex: 2">
              <span class="md-body-1">
                Simulação: {{ simulacao.currentStep + 1 }} de
                {{ simulacao.steps }}</span
              >
            </div>
            <div class="flex: 2">
              {{ formatDate(simulacao.horarioSteps[simulacao.currentStep]) }}
            </div>
            <div class="flex: 1">
              <md-button
                class="md-icon-button md-dense md-primary"
                @click="openSearchData = true"
              >
                <md-icon>search</md-icon>
              </md-button>
            </div>
          </div>
          <div style="display: flex">
            <md-button
              class="m-0"
              :disabled="simulacaoLoading"
              @click="() => handleStepClick(-1)"
            >
              <md-icon>first_page</md-icon>
            </md-button>
            <input
              v-model.number="simulacao.currentStep"
              :disabled="simulacaoLoading"
              class="m-0"
              style="width: 100%"
              type="range"
              min="0"
              :max="simulacao.steps - 1"
              @input="
                (e) => {
                  simulacaoApplyPatterns = true
                  loadSimulacao({ step: +e.target.value })
                }
              "
            />
            <md-button
              class="m-0"
              :disabled="simulacaoLoading"
              @click="() => handleStepClick(1)"
            >
              <md-icon>last_page</md-icon>
            </md-button>
          </div>
        </div>
      </div>
      <EpanetHeatmap
        ref="map"
        :style-map="mapConfig.style"
        :three-d="threeD"
        :local-id="localId"
        :region="region"
        :pontos="pontos"
        :lines="lines"
        :reservatorios="reservatorios"
        :geojson-ref="simulacaoGeojson"
        :point="tempPoint"
        :temp-point-line="createLinkMetadata.tempTo"
        :real-time="simulacao === null"
        @update="toggleTab"
        @calibrado="horarioCalibracao = new Date()"
        @clickmap="handleOnClickEpanetMap"
        @mousemovemap="handleMouseMoveMap"
        @clickequipamento="handleEquipamentoClick"
      />
    </div>
    <slider-right
      id="slideLeft"
      ref="slider"
      size="30%"
      :close-on-click-outside="false"
    >
      <EpanetHeatmapHistorico
        v-if="sliderShow === 'PROPS'"
        :id-juncao="idJuncao"
        :properties="properties"
        :editable="simulacao !== null"
        @close="() => closeSlider()"
        @save="editEpanetHandler"
        @delete="deleteEpanetHandler"
      />

      <EpanetShowConsumos
        v-if="sliderShow === 'CONSUMO'"
        :consumos="consumos"
        :editable="simulacao !== null"
        @save="editEpanetConsumosHandler"
        @close="() => closeSlider()"
      ></EpanetShowConsumos>

      <EpanetCreateNode
        v-if="sliderShow === 'CREATE_NODE' && simulacao !== null"
        :position="createNoPosition"
        :consumos="consumos"
        :nodes="nodes"
        :simulacao-id="simulacao.simulacaoId"
        @save="
          () => {
            tempPoint = null
            loadSimulacao({ forceLoad: true })
          }
        "
        @close="() => closeSlider()"
      ></EpanetCreateNode>

      <EpanetCreateLink
        v-if="sliderShow === 'CREATE_LINK' && simulacao !== null"
        :nodes="nodes"
        :simulacao-id="simulacao.simulacaoId"
        :from="createLinkMetadata.from"
        :to="createLinkMetadata.to"
        :links="links"
        @remove="removePoint"
        @flyto="(e) => flyToNode(e)"
        @save="
          () => {
            tempPoint = null
            closeSlider()
            loadSimulacao({ forceLoad: true })
          }
        "
        @close="() => closeSlider()"
      ></EpanetCreateLink>

      <EpanetEquipamentoDrawer
        v-if="sliderShow === 'EQUIPAMENTO' && selectedEquipamentoId !== null"
        :equipamento-id="selectedEquipamentoId"
        :nome="selectedEquipamentoNome"
        :epanet-id="selectedEquipamentoEpanetId"
        @close="closeSlider()"
        @show-epanet-node="handleShowEpanetNode"
      />
    </slider-right>

    <md-dialog :md-active.sync="dialogSimulacao" :md-fullscreen="true">
      <md-dialog-content>
        <EpanetRangeSimulacao
          @close="dialogSimulacao = false"
          @range="createSimulacao"
        ></EpanetRangeSimulacao>
      </md-dialog-content>
    </md-dialog>

    <md-dialog
      v-if="simulacao !== null"
      :md-active.sync="openSearchData"
      :md-fullscreen="true"
    >
      <md-dialog-content>
        <EpanetRangeBuscaSimulacao
          :initial-date="simulacao.from"
          :final-date="simulacao.to"
          @close="openSearchData = false"
          @value="(e) => buscarEpanetSimulacao(e)"
        ></EpanetRangeBuscaSimulacao>
      </md-dialog-content>
    </md-dialog>

    <div class="mt-1" style="position: absolute">
      <div style="display: flex; align-items: start">
        <div>
          <md-button
            class="md-icon-button md-list-action md-raised"
            @click="() => $router.push(`/local/${localId}/dashboard`)"
          >
            <md-icon>arrow_back</md-icon>
            <md-tooltip md-direction="left">Voltar</md-tooltip>
          </md-button>
        </div>

        <div>
          <md-menu class="ml-2" md-direction="bottom-start">
            <md-button class="md-raised" md-menu-trigger>Opções</md-button>

            <md-menu-content>
              <md-menu-item @click="pontos = !pontos">Pontos</md-menu-item>
              <md-menu-item @click="threeD = !threeD">3D</md-menu-item>
              <md-menu-item @click="region = !region">Regiões</md-menu-item>
              <md-menu-item @click="lines = !lines">Rede</md-menu-item>
              <md-menu-item @click="reservatorios = !reservatorios">
                Reservatórios
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>

        <div v-if="canEpanetEdicao()">
          <md-menu class="ml-2" md-direction="bottom-start">
            <md-button class="md-raised" md-menu-trigger>Simulação</md-button>

            <md-menu-content>
              <md-menu-item
                v-if="simulacao === null"
                @click="dialogSimulacao = true"
              >
                Iniciar
              </md-menu-item>

              <md-menu-item
                v-if="simulacao !== null"
                @click="cancelarSimulacaoHandler"
              >
                Cancelar
              </md-menu-item>

              <md-menu-item
                v-if="simulacao !== null && isAdmin()"
                @click="downloadInpModel"
              >
                INP MODEL
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>

        <div>
          <md-menu class="ml-2" md-direction="bottom-start" md-align-trigger>
            <md-button class="md-raised" md-menu-trigger>Mapa</md-button>

            <md-menu-content>
              <md-menu-item
                v-for="style in mapConfig.stylesOptions"
                :key="style.label"
                @click="
                  mapConfig.style = style.value
                  $store.commit('setEpanetStyle', style.value)
                "
              >
                {{ style.label }}
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>

        <div class="m-0 p-0">
          <md-button class="mt-0 md-button md-raised">
            <md-progress-spinner
              v-if="simulacao == null && horarioCalibracao === null"
              :md-diameter="20"
              :md-stroke="3"
              md-mode="indeterminate"
            />
            <span v-else>
              {{
                simulacao != null
                  ? 'Simulação ativada - ' +
                    (simulacaoExecutadoStep != null
                      ? simulacaoExecutadoStep + 1
                      : '...')
                  : horarioCalibracao
                  ? horarioCalibracao.toLocaleTimeString()
                  : ''
              }}
            </span>
            <md-progress-spinner
              v-if="simulacaoLoading"
              :md-diameter="20"
              :md-stroke="3"
              md-mode="indeterminate"
            />
          </md-button>
          <md-tooltip md-direction="bottom">Horário da calibração</md-tooltip>
        </div>

        <div class="m-0 p-0">
          <md-button
            v-if="simulacao !== null"
            class="mt-0 md-button md-raised"
            @click="clickConsumoHandler"
          >
            Consumos
          </md-button>
        </div>

        <div class="m-0 p-0">
          <md-button
            v-if="simulacao !== null"
            class="mt-0 md-button md-raised"
            @click="handleCreateNodeInput"
          >
            Criar Nó
          </md-button>
        </div>

        <div class="m-0 p-0">
          <md-button
            v-if="simulacao !== null"
            class="mt-0 md-button md-raised"
            @click="handleCreateLinkInput"
          >
            Criar Rede
          </md-button>
        </div>

        <div class="m-0 p-0">
          <div v-if="allSearchItems.length > 0" class="epanet-search-box">
            <md-autocomplete
              v-model="epanetSearch"
              :md-options="autoCompleteTemp"
              md-dense
              @md-changed="getSearchResults"
              @md-opened="getSearchResults"
              @md-selected="handleSearchSelect"
            >
              <label>Buscar</label>
              <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                <md-icon style="font-size: 16px !important">
                  {{ item.group === 'PCP' ? 'place' : 'linear_scale' }}
                </md-icon>
                <md-highlight-text :md-term="term"
                  >{{ item.id }}
                </md-highlight-text>
              </template>
              <template slot="md-autocomplete-empty" slot-scope="{ term }">
                Nenhum resultado para "{{ term }}"
              </template>
            </md-autocomplete>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileDownload from 'js-file-download'
import moment from 'moment/moment'

import EpanetCreateLink from '@/components/epanet/EpanetCreateLink.vue'
import EpanetCreateNode from '@/components/epanet/EpanetCreateNode.vue'
import EpanetEquipamentoDrawer from '@/components/epanet/EpanetEquipamentoDrawer.vue'
import EpanetRangeBuscaSimulacao from '@/components/epanet/EpanetRangeBuscaSimulacao.vue'
import EpanetRangeSimulacao from '@/components/epanet/EpanetRangeSimulacao.vue'
import EpanetShowConsumos from '@/components/epanet/EpanetShowConsumos.vue'
import EquipamentoSelecionarSensor from '@/components/equipamento/EquipamentoSelecionarSensor.vue'
import { EventBus, Topics, Types } from '@/event-bus'
import auth from '@/utils/auth'
import http from '@/utils/http'
import { AsyncLock } from '@/utils/lock'

import EpanetHeatmap from '../../components/epanet/EpanetHeatmap.vue'
import EpanetHeatmapHistorico from '../../components/epanet/EpanetHeatmapHistorico.vue'
import SliderRight from '../../components/SliderLeft'

export default {
  name: 'EpanetHeatmapIndex',
  components: {
    EpanetRangeBuscaSimulacao,
    EpanetCreateLink,
    EpanetCreateNode,
    EpanetShowConsumos,
    EpanetRangeSimulacao,
    EquipamentoSelecionarSensor,
    EpanetHeatmap,
    SliderRight,
    EpanetHeatmapHistorico,
    EpanetEquipamentoDrawer,
  },
  data() {
    return {
      idJuncao: '',
      properties: {},
      localId: null,
      simulacaoId: null,
      horarioCalibracao: null,
      threeD: false,
      historico: false,
      region: false,
      lines: false,
      reservatorios: false,
      consumos: [],
      sliderShow: 'NONE',
      pontos: true,
      tempPoint: null,
      dialogSimulacao: false,
      createNoPosition: null,
      simulacao: null,
      simulacaoApplyPatterns: true,
      simulacaoLastStep: null,
      simulacaoLoading: false,
      simulacaoExecutadoStep: null,
      simulacaoGeojson: null,
      createLinkMetadata: {
        from: null,
        to: null,
        tempTo: null,
      },
      nodes: {},
      links: {},
      simulacaoLock: new AsyncLock(),
      openSearchData: false,
      epanetSearch: null,
      selectedEquipamentoId: null,
      selectedEquipamentoNome: '',
      selectedEquipamentoEpanetId: null,
      autoCompleteTemp: [],
      mapConfig: {
        style: 'mapbox://styles/mapbox/streets-v12',
        stylesOptions: [
          {
            label: 'Padrão',
            value: 'mapbox://styles/mapbox/streets-v12',
          },
          {
            label: 'Escuro',
            value: 'mapbox://styles/mapbox/dark-v10',
          },
          {
            label: 'Satélite',
            value: 'mapbox://styles/mapbox/satellite-streets-v12',
          },
          {
            label: 'Navegação escuro',
            value: 'mapbox://styles/mapbox/navigation-preview-night-v4',
          },
          {
            label: 'Relevo',
            value: 'mapbox://styles/mapbox/outdoors-v12',
          },
        ],
      },
    }
  },
  computed: {
    allSearchItems() {
      const items = []
      Object.values(this.nodes).forEach((f) => {
        const label = `Nó: ${f.properties.id}`
        items.push({
          id: f.properties.id,
          group: 'PCP',
          coordinates: f.geometry.coordinates,
          toLowerCase: () => label.toLowerCase(),
          toString: () => label,
        })
      })
      Object.values(this.links).forEach((f) => {
        const label = `Link: ${f.properties.id}`
        const c = f.geometry.coordinates
        const mid = [(c[0][0] + c[1][0]) / 2, (c[0][1] + c[1][1]) / 2]
        items.push({
          id: f.properties.id,
          group: 'LINE',
          coordinates: mid,
          toLowerCase: () => label.toLowerCase(),
          toString: () => label,
        })
      })
      return items
    },
  },
  beforeMount() {
    this.mapConfig.style = this.$store.state.epanetStyle || this.mapConfig.style
    this.localId = this.$route.params.localId
    this.$store.commit('togglePaddingPage')
    this.$store.commit('setToolbarView', false)
  },
  async mounted() {
    const url = new URL(window.location)
    if (url.searchParams.get('sid') && url.searchParams.get('steps')) {
      this.simulacao = {
        simulacaoId: url.searchParams.get('sid'),
        steps: url.searchParams.get('steps'),
        currentStep: +url.searchParams.get('steps') - 1,
        from: new Date(url.searchParams.get('from')),
        to: new Date(url.searchParams.get('to')),
        horarioSteps: [],
      }
      await this.loadSimulacao()
      await this.loadHorarioSteps()
    }

    document.addEventListener('keydown', this.closeSliderListener)
  },
  beforeDestroy() {
    this.$store.commit('togglePaddingPage')
    this.$store.commit('setToolbarView', true)

    document.removeEventListener('keydown', this.closeSliderListener)
  },
  methods: {
    isAdmin: auth.isAdmin,
    handleEquipamentoClick(e) {
      this.selectedEquipamentoId = String(e.id)
      this.selectedEquipamentoNome = e.nome
      this.selectedEquipamentoEpanetId = e.epanetId || null
      this.sliderShow = 'EQUIPAMENTO'
      setTimeout(() => {
        if (this.$refs.slider.isOpened() === false) {
          this.$refs.slider.toogleTab()
        }
      }, 0)
    },
    handleShowEpanetNode(epanetId) {
      const feature = this.$refs.map.getNodeById(epanetId)
      if (!feature) return
      this.toggleTab({
        idJuncao: epanetId,
        properties: feature.properties,
        x: feature.geometry.coordinates[0],
        y: feature.geometry.coordinates[1],
      })
    },
    closeSliderListener(event) {
      if (event.key === 'Escape') {
        this.closeSlider()
      }
    },
    canEpanetEdicao() {
      return auth.canEpanetEdicao()
    },
    flyToNode(e) {
      const node = this.nodes[e.idJuncao]

      if (node == null) {
        return
      }

      this.$refs.map.flyTo({
        coordinates: node.geometry.coordinates,
      })
    },
    getSearchResults(term) {
      if (!term) {
        this.autoCompleteTemp = []
        return
      }
      const lower = term.toLowerCase()
      const results = []
      for (const item of this.allSearchItems) {
        if (item.toLowerCase().includes(lower)) {
          results.push(item)
          if (results.length >= 30) break
        }
      }

      this.autoCompleteTemp = results
    },
    handleSearchSelect(item) {
      if (!item || typeof item !== 'object') return
      this.$refs.map.flyTo({ coordinates: item.coordinates, zoom: 18 })
      this.$refs.map.highlightPoint({ coordinates: item.coordinates })
      this.$nextTick(() => {
        this.epanetSearch = null
      })
    },
    async loadConsumos() {
      if (this.simulacao === null) {
        return
      }

      const response = await http.get(
        `epanet/simulacao/${this.simulacao.simulacaoId}/consumo`
      )

      if (response == null) {
        return
      }

      this.consumos = response.consumos
    },
    cancelarSimulacaoHandler() {
      if (this.simulacao === null) {
        return
      }

      this.closeSlider()

      this.simulacao = null

      const url = new URL(window.location)
      url.searchParams.delete('sid')
      url.searchParams.delete('steps')
      url.searchParams.delete('from')
      url.searchParams.delete('to')

      window.history.pushState(null, '', url.toString())

      EventBus.$emit(Topics.NOTIFICATIONS, {
        type: Types.INFO,
        message: 'Simulação cancelada com sucesso',
      })
    },
    async clickConsumoHandler() {
      if (this.simulacao === null) {
        return
      }

      this.sliderShow = 'CONSUMO'

      await this.loadConsumos()

      setTimeout(() => {
        if (this.$refs.slider.isOpened() === false) {
          this.$refs.slider.toogleTab()
        }
      }, 0)
    },
    toggleTab(e) {
      if (this.sliderShow === 'CREATE_LINK') {
        if (e.properties.group !== 'PCP') {
          return
        }

        if (!this.createLinkMetadata.from) {
          this.createLinkMetadata.from = {
            ...e,
            id: e.idJuncao,
          }

          this.tempPoint = {
            x: e.x,
            y: e.y,
          }
        } else {
          if (e.idJuncao === this.createLinkMetadata.from.id) {
            return
          }

          this.createLinkMetadata.to = {
            ...e,
            id: e.idJuncao,
          }
        }

        return
      }

      this.sliderShow = 'PROPS'

      this.idJuncao = e.idJuncao
      this.properties = {
        ...e.properties,
        id: e.idJuncao,
      }
      setTimeout(() => {
        if (this.$refs.slider.isOpened() === false) {
          this.$refs.slider.toogleTab()
        }
      }, 0)
    },
    handleMouseMoveMap(e) {
      if (this.sliderShow === 'CREATE_LINK') {
        if (this.createLinkMetadata.to) {
          return
        }

        const position = {
          x: e.lngLat.lat,
          y: e.lngLat.lng,
        }

        if (this.createLinkMetadata.from) {
          this.createLinkMetadata.tempTo = {
            coordinates: [position.y, position.x],
          }
        }
      }
    },
    handleOnClickEpanetMap(e) {
      if (this.sliderShow === 'CREATE_NODE') {
        this.createNoPosition = {
          x: e.lngLat.lat,
          y: e.lngLat.lng,
        }

        this.tempPoint = {
          x: e.lngLat.lng,
          y: e.lngLat.lat,
        }
      }
    },
    async createSimulacao(range) {
      const response = await http.get(
        'epanet/simulacao/local/' + this.localId,
        {
          from: range.initialDate.toISOString(),
          to: range.finalDate.toISOString(),
        }
      )

      if (response == null) {
        return
      }

      this.dialogSimulacao = false

      EventBus.$emit(Topics.NOTIFICATIONS, {
        type: Types.INFO,
        message: 'Simulação criada com sucesso',
      })

      this.simulacao = {
        simulacaoId: response.simulacaoId,
        steps: response.steps,
        currentStep: +response.steps - 1,
        horarioSteps: response.horarioSteps,
        from: range.initialDate,
        to: range.finalDate,
      }

      const url = new URL(window.location)
      url.searchParams.set('sid', response.simulacaoId)
      url.searchParams.set('steps', response.steps)
      url.searchParams.set('from', range.initialDate.toISOString())
      url.searchParams.set('to', range.finalDate.toISOString())

      window.history.pushState(null, '', url.toString())

      await this.loadSimulacao({
        step: 1,
        forceLoad: true,
      })
      await this.loadHorarioSteps()
    },
    removePoint(type) {
      if (type === 'from') {
        this.tempPoint = null
        this.createLinkMetadata.from = null
        this.createLinkMetadata.to = null
        this.createLinkMetadata.tempTo = null
      } else if (type === 'to') {
        this.createLinkMetadata.to = null
        this.createLinkMetadata.tempTo = null
      }
    },
    closeSlider() {
      this.createLinkMetadata = {
        from: null,
        to: null,
        tempTo: null,
      }
      this.sliderShow = 'none'
      this.tempPoint = null
      this.createNoPosition = null
      if (this.$refs.slider.isOpened()) {
        this.$refs.slider.toogleTab()
      }
    },
    async editEpanetConsumosHandler(event) {
      this.simulacaoApplyPatterns = false
      const { changed } = event

      if (this.simulacao === null) {
        return
      }

      if (changed === null) {
        return
      }

      if (Object.keys(changed).length === 0) {
        return
      }

      const promises = Object.entries(changed).map(([key, value]) =>
        http.post(
          `epanet/simulacao/${this.simulacao.simulacaoId}/consumo`,
          {
            uid: value.uid,
            value: value.value,
          },
          false
        )
      )

      this.simulacaoLoading = true

      await Promise.all(promises)

      await this.loadSimulacao({ forceLoad: true })
    },
    async deleteEpanetHandler({ group, original }) {
      if (this.simulacao === null) {
        return
      }

      this.simulacaoLoading = true

      await http.post(
        `epanet/simulacao/${this.simulacao.simulacaoId}/delete`,
        {
          tipo: group,
          uid: original.id,
        },
        false
      )

      this.closeSlider()

      await this.loadSimulacao({ forceLoad: true })

      this.simulacaoLoading = false
    },
    async editEpanetHandler({ group, changed }) {
      if (this.simulacao === null) {
        return
      }

      if (changed === null) {
        return
      }

      if (Object.keys(changed).length === 0) {
        return
      }

      this.simulacaoLoading = true

      await http.post(
        'epanet/simulacao/change',
        {
          tipo: group,
          simulacaoId: this.simulacao.simulacaoId,
          uid: this.idJuncao,
          dados: changed,
        },
        false
      )

      await this.loadSimulacao({ forceLoad: true })

      this.simulacaoLoading = false
    },
    async handleCreateNodeInput() {
      this.sliderShow = 'CREATE_NODE'

      await this.loadConsumos()

      setTimeout(() => {
        if (this.$refs.slider.isOpened() === false) {
          this.$refs.slider.toogleTab()
        }
      }, 0)
    },
    async handleCreateLinkInput() {
      this.sliderShow = 'CREATE_LINK'

      await this.loadConsumos()

      setTimeout(() => {
        if (this.$refs.slider.isOpened() === false) {
          this.$refs.slider.toogleTab()
        }
      }, 0)
    },
    async downloadInpModel() {
      if (this.simulacao === null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Não existe simulação em andamento',
        })
      }

      const response = await http.get(
        `epanet/simulacao/${this.simulacao.simulacaoId}/export`
      )
      if (response) {
        fileDownload(response.inp, `flow-${this.simulacao.simulacaoId}.inp`)
      }
    },
    handleStepClick(delta) {
      if (this.simulacao === null || this.simulacaoLoading) {
        return
      }

      if (
        this.simulacao.currentStep + delta < 0 ||
        this.simulacao.currentStep + delta >= this.simulacao.steps
      ) {
        return
      }

      this.simulacao.currentStep += delta
      this.loadSimulacao()
    },
    async loadHorarioSteps() {
      if (this.simulacao === null) {
        return
      }

      const response = await http.get(
        'epanet/simulacao/local/' + this.localId + '/steps',
        {
          from: this.simulacao.from,
          to: this.simulacao.to,
        }
      )

      if (response == null) {
        return
      }

      this.simulacao.horarioSteps = response.horarioSteps.map(
        (e) => new Date(Date.parse(e))
      )
    },
    formatDate(date) {
      return moment(date).format('HH:mm DD/MM/YY')
    },
    async loadSimulacao({ step = null, forceLoad = false } = {}) {
      await this.simulacaoLock.lock()

      const stepToExecute = step || this.simulacao.currentStep

      if (
        forceLoad === false &&
        this.simulacaoLastStep !== null &&
        this.simulacaoLastStep === stepToExecute
      ) {
        this.simulacaoLock.unlock()
        return
      }

      this.simulacaoLoading = true

      let shouldCreate = false

      try {
        const response = await http.get(
          'epanet/simulacao/' + this.simulacao.simulacaoId,
          {
            step: stepToExecute,
            applyPatterns: this.simulacaoApplyPatterns,
          },
          false
        )

        if (response) {
          this.simulacaoGeojson = response.geoJson

          response.errors.forEach((e) => {
            EventBus.$emit(Topics.NOTIFICATIONS, {
              type: Types.WARNING,
              message: e,
            })
          })

          this.nodes = {}
          this.links = {}

          this.simulacaoGeojson.features.forEach((e) => {
            if (e.properties.group === 'PCP') {
              if (e.properties.id === null) {
                return
              }

              this.nodes[e.properties.id] = e
            }

            if (e.properties.group === 'LINE') {
              if (e.properties.id === null) {
                return
              }

              this.links[e.properties.id] = e
            }
          })
        } else {
          shouldCreate = true
        }
      } catch (e) {
        shouldCreate = true
      } finally {
        this.simulacaoExecutadoStep = stepToExecute
        this.simulacaoLastStep = stepToExecute

        this.simulacaoLoading = false

        this.simulacaoLock.unlock()
      }

      if (shouldCreate) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.INFO,
          message: 'Criando simulação',
        })
        await this.createSimulacao({
          initialDate: this.simulacao.from,
          finalDate: this.simulacao.to,
        })
      }
    },
    buscarEpanetSimulacao(date) {
      this.openSearchData = false

      if (this.simulacao === null) {
        return
      }

      if (date == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Data não informada',
        })
        return
      }

      if (date < this.simulacao.from || date > this.simulacao.to) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Data fora do intervalo da simulação',
        })
        return
      }

      let mostRecent = null
      let index = 0

      this.simulacao.horarioSteps.forEach((e) => {
        if (mostRecent === null) {
          mostRecent = {
            time: e,
            diff: null,
            index: index,
          }
        }

        const diff = Math.abs(e.getTime() - date.getTime())

        if (mostRecent.diff == null) {
          mostRecent.diff = Math.abs(mostRecent.time.getTime() - date.getTime())
        }

        if (diff < mostRecent.diff) {
          mostRecent = {
            time: e,
            diff: diff,
            index: index,
          }
        }

        index = index + 1
      })

      this.simulacao.currentStep = mostRecent.index
      this.loadSimulacao()
    },
  },
}
</script>

<style lang="scss" scoped>
.noMargin {
  margin: 0;
}

.conteudoContainer {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.mapa {
  height: 100%;
}

.stepper {
  padding: 0.2rem;
  position: absolute;
  z-index: 999;
  bottom: 0;
  left: 5vh;
  background-color: #f5f5f5;
  border-radius: 0 0.5rem 0.5rem 0;
}

.epanet-search-box {
  min-width: 280px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  padding: 0 12px;
  z-index: 10;
}
</style>
